import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>MTS 2 at Adobe <span>2019-present</span></h2>
                        <p>- I am a part of CLOUD TECH at ADOBE</p>
                        <p>- FULL-STACK and Distributed Microservices development in Java and JavaScript.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Software Engineer at Cisco <span>2018-2019</span></h2>
                        <p>- L2/L3 developer (C/C++)</p>
<p>- Working as a part of the Nexus OS team in Data Centre Business Unit.</p>
<p>- Working on Platform Independent Components which provide and improve Debug Infrastructure.</p>
<p>- Security features for components (CSDL for Nexus OS)</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>MTS 1 at Mojo Networks <span>2017-2018</span></h2>
<p>- Working on Mojo Network's Core Product MWM a cloud-based software for intelligent WIFI mangement.</p>
<p>- C/C++ PSQL</p>
<p><a href="https://www.arista.com/en/company/news/press-release/5717-pr-20180802">Acquired by Arista Networks</a></p>

                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Intern Programmer at Ubisoft <span>2016-2017</span></h2>
<p>
- In Game sub-systems
1. Leaderboard
2. Friends system
3. Uplay Integration.
</p>
<p>
- C++ OOPS Peer to Peer Networks
</p>
<p><a href="https://www.mobygames.com/game/windows/monopoly-plus/credits">Monopoly Plus Credits Page</a></p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>C Programmer at PICT ROBOCON LAB <span>2014-2017</span></h2>
                        <p>- Member of the prestigious PICT ROBOCON TEAM for 2 years. </p> 
                        <p>- Worked on autonomous robots,Image processing,PS2 controller for locomotion in embedded C.</p>
                        <p><a href="https://pict.edu/cocurricular/robocon/">PICT Robocon Lab</a></p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Engineering at PICT <span>2013-2017</span></h2>
                        <p>- Bachelor of Engineering in Information Technology </p> 
                        <p>- 8.17 CGPA </p> 
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
